<section class="centered-with-padding py-7">
  @if (data.title; as title) {
    <div class="pb-11">
      <app-title [title]="{ text: title, as: 'span' }" size="h2" />
    </div>
  }
  <div class="grid grid-cols-1 gap-y-4 desk:grid-cols-2 desk:gap-3">
    @for (testimony of testimonies(); track testimony.url) {
      <a
        [routerLink]="testimony.url"
        class="group relative block h-[370px] cursor-pointer overflow-hidden rounded-2xl text-white desk:block">
        <div class="absolute -z-20 size-full">
          <app-image
            [hoverEffect]="true"
            [image]="testimony.image"
            [isPriority]="!isImageInPreviousBlocks && $index < 2"
            [pregenerationSize]="{ width: 534, height: 370 }" />
        </div>
        <div class="absolute inset-0 -z-10 bg-gradient-to-b from-transparent to-black/50"></div>
        <div class="flex size-full flex-col justify-end p-5">
          <div class="w-fit pb-3 opacity-60">
            <app-svg [height]="50" [inline]="true" [width]="64" class="text-white" src="assets/icons/quote.svg" />
          </div>
          <div [innerHTML]="testimony.text" class="pb-1 text-[14px] leading-[17px]"></div>
          <div class="flex items-center gap-2">
            <span class="font-bold italic">{{ testimony.author }}</span>
            <app-svg [height]="9" [inline]="true" [width]="14" class="text-white" src="assets/icons/arrow-right.svg" />
          </div>
        </div>
      </a>
    }
  </div>
  @if (hasMoreTestimonies()) {
    <div class="mx-auto mt-5 w-fit">
      <app-button
        (onButtonClick)="loadMore()"
        [label]="'COMPONENT.LISTING-TEMOIGNAGES.SEE_MORE_TESTIMONIES' | translate" />
    </div>
  }
</section>
